import http from '@/utils/httpService';
import { rootPath, rootPath2 } from '@/utils/globalParam';
import fileExport from '@/utils/fileExportForGet';
import fileExport1 from '@/utils/fileExport';
// 企业树
export const treeData = data => {
  return http.Axios.post(rootPath + '/api/enterprise/treeData', data);
};
// 账号新增
export const addUser = data => http.Axios.post(rootPath + '/api/user/save', data);

// 账号编辑
export const editUser = data => http.Axios.post(rootPath + '/api/user/update', data);

// 账号离职
export const leaveUser=data=>{
    return http.Axios.post(rootPath+'/api/user/updateLeaveStatus',data)
}
// 重置密码
export const resetPwd=data=>{
    return http.Axios.post(rootPath+'/api/user/passwordReset',data)
}
// 下载模版
export const downloadTemplate = data => {
  return fileExport('账号批量导入.xlsx', data, '/api/user/downloadTemplate');
};
// 查询列表
export const queryUserList = data => http.Axios.post(rootPath + '/api/user/page', data);
// 查询条件导出
export const exportUser = (fileName, data = {}) => {
  return fileExport1(fileName, data, '/api/user/export');
};

// 根据userId获取用户
export const getUserByUserId = data => http.Axios.post(rootPath + '/api/user/getUserByUserId', data);

/* ------------
    企业架构
------------- */
// 企业架构列表
export const queryFramePage = data => http.Axios.post(rootPath + '/api/enterprise/showlist', data, { noLoading: true });
// 企业架构树形图
export const queryFrameTree = data => http.Axios.post(rootPath + '/api/enterprise/treeData', data, { noLoading: true });
// 企业架构删除
export const deleteFramePage = data =>
  http.Axios.post(rootPath + '/api/enterprise/deleteEnt', data, { noLoading: true });
// 企业架构数据导出
export const exportFrame = (fileName, data) => fileExport1(fileName, data, '/api/enterprise/export');

// 企业架构删除
export const getSiblingEnterprise = data =>
  http.Axios.post(rootPath + '/api/user/getSiblingEnterprise',  { noLoading: true });
